export default "__VITE_ASSET__BWUKR2FT__"